const ACCOUNTING_CONFIG_BY_LOCALE = require('./data/accounting_config/accountingConfigByLocale.json');

module.exports = {ACCOUNTING_CONFIG_BY_LOCALE};
